<template>
  <v-card
    v-if="!articlesInCart().length"
    class="ma-10"
    outlined
  >
    <v-card-title> Tu cesta está vacía </v-card-title>
    <v-card-text>
      Continúa comprando
      <router-link to="/articles">aquí</router-link>
    </v-card-text>
  </v-card>
  <div v-else>
    <v-card-title class="pb-0 ml-2">Artículos en la cesta:</v-card-title>
    <ArticleList origin="2"> </ArticleList>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ArticleList from "@/components/utils/ArticleList.vue";

export default {
  components: { ArticleList },

  data() {
    return {};
  },

  methods: {
    ...mapGetters(["articlesInCart"]),
  },
};
</script>
